import uniqBy from 'lodash/uniqBy';
import find from 'lodash/find';
import * as track from 'lib/gaTracking/bookingListPageEvents';
import { BookingListResponseData } from './types';
import { FILTER_OPTIONS, OPTIONS } from './constants';

interface UpdateQuerySecondArgument {
  fetchMoreResult: BookingListResponseData;
}

interface CreateFetchMoreHandlerArguments {
  filter?: string;
  data: BookingListResponseData;
  fetchMore: Function;
}

const updateQuery = (prev: BookingListResponseData, { fetchMoreResult }: UpdateQuerySecondArgument) => {
  if (!fetchMoreResult) {
    return prev;
  }

  const { bookings = [], hasMore = false } = fetchMoreResult.bookingList;
  return {
    bookingList: {
      ...prev.bookingList,
      bookings: uniqBy([...prev.bookingList.bookings, ...bookings], 'id'),
      hasMore,
    },
  };
};

export const createFetchMoreHandler = ({ data, fetchMore, filter }: CreateFetchMoreHandlerArguments) => () => {
  if (!data || !fetchMore) return null;

  const offset = data.bookingList.bookings.length;

  track.loadMoreButton(offset, filter);

  fetchMore({
    variables: { offset },
    updateQuery,
  });
};

export const getCurrentFilterLabel = (value: string) => {
  const optionLabel = (find(OPTIONS, { value }) || {}).label;
  return optionLabel ? `${optionLabel} bookings` : '';
};

export const getBookingCountLabel = (data?: BookingListResponseData) => {
  let totalOfBookings = 0;
  if (data && data.bookingList && data.bookingList.bookings) {
    totalOfBookings = data.bookingList.bookings.length;
  }
  return `${totalOfBookings} booking${totalOfBookings === 1 ? '' : 's'} found`;
};

export const getQueryFilter = (value: string) => {
  return find(FILTER_OPTIONS, { value: value })?.queryFilter;
};
